import { render } from "./uiAlert.vue?vue&type=template&id=e525f9c4&scoped=true"
import script from "./uiAlert.vue?vue&type=script&lang=js"
export * from "./uiAlert.vue?vue&type=script&lang=js"

import "./uiAlert.vue?vue&type=style&index=0&id=e525f9c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e525f9c4"]])

export default __exports__